export const optionStatus = [
  {
    text: "On Track",
    value: "open",
  },
  {
    text: "At Risk",
    value: "at_risk",
  },
  {
    text: "Off Track",
    value: "off_track",
  },
  {
    text: "Closed",
    value: "closed",
  },
];

export const priorityOptions = [
  {
    text: "High",
    value: "high",
  },
  {
    text: "Medium",
    value: "medium",
  },
  {
    text: "Low",
    value: "low",
  },
];
